"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.H_MENU_CONTAINER = exports.V_MENU_CONTAINER = exports.H_MENU = exports.V_MENU = exports.TAB_ICON = exports.TAB_WRAPPER = exports.DRAWER_CONTENT_CONTAINER = exports.DRAWER_CONTENT = exports.MENU = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

var TAB_PADDING_TOP = "70px",
    V_MINIMISED_MENU = {
  width: "10px",
  paddingLeft: 0,
  paddingRight: 0
},
    H_MINIMISED_MENU = {
  height: "10px",
  paddingTop: 0,
  paddingBottom: 0
},
    MENU = {
  display: "flex",
  position: "fixed",
  background: _vars.COLOURS.grey.codGrey,
  color: _vars.COLOURS.mono.white,
  overflow: "visible"
};
exports.MENU = MENU;

var DRAWER_CONTENT = function DRAWER_CONTENT(a) {
  var b = a.hasTabIcons,
      c = a.menuSize,
      d = a.isVertical;
  return (0, _cxs["default"])({
    display: "flex",
    flexDirection: "column",
    flex: 1,
    padding: "20px",
    width: b ? "calc(".concat(d ? "".concat(c, "px") : "100%", " - ").concat(TAB_PADDING_TOP, ")") : "100%"
  });
};

exports.DRAWER_CONTENT = DRAWER_CONTENT;
var DRAWER_CONTENT_CONTAINER = (0, _cxs["default"])({
  display: "flex",
  flexDirection: "row",
  height: "100%"
});
exports.DRAWER_CONTENT_CONTAINER = DRAWER_CONTENT_CONTAINER;
var TAB_WRAPPER = (0, _cxs["default"])({
  width: "70px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "center",
  background: _vars.COLOURS.mono.black,
  height: "calc(100% - ".concat("70px", ")"),
  paddingTop: "70px"
});
exports.TAB_WRAPPER = TAB_WRAPPER;

var TAB_ICON = function TAB_ICON(a) {
  return (0, _cxs["default"])({
    padding: "10px 0",
    width: "70px",
    background: a ? _vars.COLOURS.grey.codGrey : void 0
  });
};

exports.TAB_ICON = TAB_ICON;

var V_MENU_TRANSITION = {
  transition: "width .3s ease-in-out, padding .3s ease-in-out"
},
    H_MENU_TRANSITION = {
  transition: "height .3s ease-in-out, padding .3s ease-in-out"
},
    V_MENU = function V_MENU(a) {
  var b = a.menuSize,
      c = a.minimised,
      d = a.hasTabIcons;
  return (0, _cxs["default"])(_objectSpread({}, MENU, {}, V_MENU_TRANSITION, {
    right: 0,
    top: 0,
    bottom: 0,
    height: "100%",
    maxWidth: "calc(100vw - 20px)",
    width: d ? "calc(".concat(b, "px + ").concat(TAB_PADDING_TOP, ")") : "".concat(b, "px"),
    flexDirection: "column"
  }, c ? V_MINIMISED_MENU : {}));
};

exports.V_MENU = V_MENU;

var H_MENU = function H_MENU(a) {
  var b = a.menuSize,
      c = a.minimised;
  return (0, _cxs["default"])(_objectSpread({}, MENU, {}, H_MENU_TRANSITION, {
    bottom: 0,
    width: "100%",
    height: "".concat(b, "px"),
    maxHeight: "calc(100vh - 20px)",
    flexDirection: "row"
  }, c ? H_MINIMISED_MENU : {}));
};

exports.H_MENU = H_MENU;

var V_MENU_CONTAINER = function V_MENU_CONTAINER(a) {
  var b = a.menuSize,
      c = a.minimised,
      d = a.hasTabIcons;
  return (0, _cxs["default"])(_objectSpread({}, V_MENU_TRANSITION, {
    height: "100%",
    width: d ? "calc(".concat(b, "px + ").concat(TAB_PADDING_TOP, ")") : "".concat(b, "px"),
    zIndex: 5
  }, c ? V_MINIMISED_MENU : {}));
};

exports.V_MENU_CONTAINER = V_MENU_CONTAINER;

var H_MENU_CONTAINER = function H_MENU_CONTAINER(a) {
  var b = a.menuSize,
      c = a.minimised;
  return (0, _cxs["default"])(_objectSpread({}, H_MENU_TRANSITION, {
    position: "absolute",
    width: "100%",
    height: "".concat(b, "px"),
    zIndex: 5
  }, c ? H_MINIMISED_MENU : {}));
};

exports.H_MENU_CONTAINER = H_MENU_CONTAINER;